export default function getResource(label, vars = []) {
    const resources = {
        codesExhaustedHeading: 'All available promo codes have been claimed.',
        codesExhaustedBody: 'But since you’re here enjoy more offers from Sephora.',
        shopNow: 'Shop Now',
        promotionEndedHeading: 'This offer has ended.',
        promotionEndedBody: 'But since you’re here enjoy more offers from Sephora.',
        alreadyRegisteredHeading: `You have already signed up for your ${vars[0]} off!`,
        alreadyRegisteredBody: 'Check your email for details.',
        selfRegistrationHeading: 'Oops, you can\'t redeem your own link.',
        selfRegistrationBody: 'Share it with a friend, or shop other offers below.'
    };

    return resources[label];
}
